var _defineProperty = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
module.exports = function (modules) {
  var installedModules = {};
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js": function __node_modules_Babel_runtimeCorejs3_coreJs_object_definePropertyJs(module, exports, __webpack_require__) {
    module.exports = __webpack_require__("core-js-pure/features/object/define-property");
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js": function __node_modules_Babel_runtimeCorejs3_helpers_classCallCheckJs(module, exports) {
    module.exports = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
  },
  "../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js": function __node_modules_Babel_runtimeCorejs3_helpers_definePropertyJs(module, exports, __webpack_require__) {
    var _Object$defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/core-js/object/define-property.js");
    module.exports = function (obj, key, value) {
      return key in obj ? _Object$defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : obj[key] = value, obj;
    };
  },
  "./index.js": function _indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "HttpTransport", function () {
      return HttpTransport_HttpTransport;
    }), __webpack_require__.d(__webpack_exports__, "HttpRequest", function () {
      return HttpRequest_HttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "HttpRequestBuilder", function () {
      return HttpRequestBuilder_HttpRequestBuilder;
    }), __webpack_require__.d(__webpack_exports__, "REQUEST_HANDLER_TYPE", function () {
      return REQUEST_HANDLER_TYPE;
    }), __webpack_require__.d(__webpack_exports__, "createJsonHttpRequest", function () {
      return createJsonHttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "createHttpRequest", function () {
      return createHttpRequest;
    }), __webpack_require__.d(__webpack_exports__, "basicAuthOptions", function () {
      return basicAuthOptions;
    }), __webpack_require__.d(__webpack_exports__, "tokenAuthOptions", function () {
      return tokenAuthOptions;
    }), __webpack_require__.d(__webpack_exports__, "jsonOptions", function () {
      return jsonOptions;
    }), __webpack_require__.d(__webpack_exports__, "langLocaleOptions", function () {
      return langLocaleOptions;
    }), __webpack_require__.d(__webpack_exports__, "analyticsHandler", function () {
      return analyticsHandler;
    }), __webpack_require__.d(__webpack_exports__, "authTokenHandler", function () {
      return authTokenHandler;
    }), __webpack_require__.d(__webpack_exports__, "zipkinTraceHandler", function () {
      return zipkinTraceHandler;
    }), __webpack_require__.d(__webpack_exports__, "fastOptionsMerge", function () {
      return fastOptionsMerge;
    });
    var now_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/date/now"),
      now_default = __webpack_require__.n(now_),
      classCallCheck = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/classCallCheck.js"),
      classCallCheck_default = __webpack_require__.n(classCallCheck),
      defineProperty = __webpack_require__("../../node_modules/@babel/runtime-corejs3/helpers/defineProperty.js"),
      defineProperty_default = __webpack_require__.n(defineProperty),
      promise_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/promise"),
      promise_default = __webpack_require__.n(promise_);
    function fastOptionsMerge(defaults, overrides) {
      var headers = _objectSpread({}, null == defaults ? void 0 : defaults.headers, {}, null == overrides ? void 0 : overrides.headers);
      return _objectSpread({}, defaults, {}, overrides, {
        headers: headers
      });
    }
    function onResolvePromise(value) {
      return promise_default.a.resolve(value);
    }
    function onRejectPromise(value) {
      return promise_default.a.reject(value);
    }
    function defaultOnTrace() {}
    function defaultOnFetch(url, options) {
      var fetchCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetch;
      return fetchCall(url, options);
    }
    var HttpTransport_HttpTransport = function HttpTransport(handlers) {
      var _this = this;
      classCallCheck_default()(this, HttpTransport), defineProperty_default()(this, "fetch", function _callee(url, method, opts) {
        var options, start, fetchWithTrace, response;
        return _regeneratorRuntime().async(function _callee$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _objectSpread({}, opts, {
                method: method
              }), start = now_default()(), fetchWithTrace = function fetchWithTrace() {
                var fetchOptions, authOptions;
                return _regeneratorRuntime().async(function fetchWithTrace$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _this.onTrace("request", {
                        url: url,
                        options: options
                      });
                      fetchOptions = options;
                      if (!_this.onAuth) {
                        _context4.next = 7;
                        break;
                      }
                      _context4.next = 5;
                      return _regeneratorRuntime().awrap(_this.onAuth());
                    case 5:
                      authOptions = _context4.sent;
                      fetchOptions = fastOptionsMerge(options, authOptions);
                    case 7:
                      return _context4.abrupt("return", fetch(url, fetchOptions));
                    case 8:
                    case "end":
                      return _context4.stop();
                  }
                }, null, null, null, Promise);
              };
              _context5.prev = 1;
              _context5.next = 4;
              return _regeneratorRuntime().awrap(_this.onFetch(url, options, fetchWithTrace));
            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.ok ? (_this.onTrace("response", {
                url: url,
                options: options,
                response: response,
                duration: now_default()() - start
              }), _this.onResponse(response)) : (_this.onTrace("error", {
                url: url,
                options: options,
                error: response,
                duration: now_default()() - start
              }), _this.onErrorResponse(response)));
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);
              return _context5.abrupt("return", (_this.onTrace("exception", {
                url: url,
                options: options,
                exception: _context5.t0,
                duration: now_default()() - start
              }), _this.onException(_context5.t0)));
            case 11:
            case "end":
              return _context5.stop();
          }
        }, null, null, [[1, 8]], Promise);
      });
      var _ref = handlers || {},
        onAuth = _ref.onAuth,
        onErrorResponse = _ref.onErrorResponse,
        onException = _ref.onException,
        onFetch = _ref.onFetch,
        onResponse = _ref.onResponse,
        onTrace = _ref.onTrace;
      this.onAuth = onAuth, this.onErrorResponse = onErrorResponse || onRejectPromise, this.onException = onException || onRejectPromise, this.onFetch = onFetch || defaultOnFetch, this.onResponse = onResponse || onResolvePromise, this.onTrace = onTrace || defaultOnTrace;
    };
    var keys_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
      keys_default = __webpack_require__.n(keys_),
      for_each_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
      for_each_default = __webpack_require__.n(for_each_),
      url_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/url"),
      url_default = __webpack_require__.n(url_),
      stringify_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/json/stringify"),
      stringify_default = __webpack_require__.n(stringify_),
      includes_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/includes"),
      includes_default = __webpack_require__.n(includes_);
    var defaultEncoder = function defaultEncoder(data, options) {
      return (null == options ? void 0 : options.headers) && (headers = options.headers)["Content-Type"] && includes_default()(_context = headers["Content-Type"]).call(_context, "application/json") ? stringify_default()(data) : data;
      var headers, _context;
    };
    function defaultResponseHandler(response) {
      if (204 === response.status) return promise_default.a.resolve(null);
      var contentType = response.headers.get("Content-Type");
      return contentType && includes_default()(contentType).call(contentType, "application/json") ? response.json() : contentType && includes_default()(contentType).call(contentType, "application/octet-stream") ? response.blob() : response.text();
    }
    function defaultErrorResponseHandler(response) {
      var message, error, contentType;
      return _regeneratorRuntime().async(function defaultErrorResponseHandler$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            error = {
              status: response.status,
              statusText: response.statusText || "<none>"
            }, contentType = response.headers.get("Content-Type");
            _context6.t0 = contentType;
            if (!_context6.t0) {
              _context6.next = 14;
              break;
            }
            if (!includes_default()(contentType).call(contentType, "application/json")) {
              _context6.next = 9;
              break;
            }
            _context6.next = 6;
            return _regeneratorRuntime().awrap(response.json());
          case 6:
            _context6.t1 = _context6.sent;
            _context6.next = 13;
            break;
          case 9:
            _context6.next = 11;
            return _regeneratorRuntime().awrap(response.text());
          case 11:
            _context6.t2 = _context6.sent;
            _context6.t1 = {
              message: _context6.t2
            };
          case 13:
            message = _context6.t1;
          case 14:
            return _context6.abrupt("return", promise_default.a.reject(_objectSpread({}, error, {}, message)));
          case 15:
          case "end":
            return _context6.stop();
        }
      }, null, null, null, Promise);
    }
    function defaultExceptionHandler(err) {
      return promise_default.a.reject(err.message);
    }
    function buildUrl(url, baseUrl) {
      return baseUrl ? new url_default.a(url, baseUrl).toString() : url;
    }
    var HttpRequest_HttpRequest = function HttpRequest(baseUrl, defaultOptions, handlerOverrides) {
      var _this2 = this;
      classCallCheck_default()(this, HttpRequest), defineProperty_default()(this, "get", function (url, params, optionOverrides) {
        var requestOptions = fastOptionsMerge(_this2.defaultOptions, optionOverrides),
          requestUrl = "".concat(buildUrl(url, _this2.baseUrl)).concat(function (params) {
            var _context;
            if (!params) return "";
            var fakeUrl = new url_default.a("http://www.gw.com");
            return for_each_default()(_context = keys_default()(params)).call(_context, function (key) {
              return fakeUrl.searchParams.append(key, params[key]);
            }), fakeUrl.search;
          }(params));
        return _this2.transport.fetch(requestUrl, "GET", requestOptions);
      }), defineProperty_default()(this, "post", function (url, data, optionOverrides) {
        return _this2.request(url, "POST", data, optionOverrides);
      }), defineProperty_default()(this, "put", function (url, data, optionOverrides) {
        return _this2.request(url, "PUT", data, optionOverrides);
      }), defineProperty_default()(this, "patch", function (url, data, optionOverrides) {
        return _this2.request(url, "PATCH", data, optionOverrides);
      }), defineProperty_default()(this, "delete", function (url, data, optionOverrides) {
        return _this2.request(url, "DELETE", data, optionOverrides);
      }), defineProperty_default()(this, "request", function (url, method, data, optionOverrides) {
        var onEncode = _this2.handlers.onEncode,
          requestOptions = fastOptionsMerge(_this2.defaultOptions, optionOverrides);
        return requestOptions.body = onEncode && data ? onEncode(data, requestOptions) : data, _this2.transport.fetch(buildUrl(url, _this2.baseUrl), method, requestOptions);
      }), this.baseUrl = baseUrl, this.defaultOptions = defaultOptions, this.handlers = _objectSpread({
        onEncode: defaultEncoder,
        onErrorResponse: defaultErrorResponseHandler,
        onException: defaultExceptionHandler,
        onResponse: defaultResponseHandler
      }, handlerOverrides), this.transport = new HttpTransport_HttpTransport(this.handlers);
    };
    var reduce_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/reduce"),
      reduce_default = __webpack_require__.n(reduce_),
      every_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/every"),
      every_default = __webpack_require__.n(every_),
      values_ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/values"),
      values_default = __webpack_require__.n(values_),
      logger_ = __webpack_require__("@jutro/logger");
    var REQUEST_HANDLER_TYPE = {
        AUTH: "onAuth",
        FETCH: "onFetch",
        ENCODE: "onEncode",
        ERROR: "onErrorResponse",
        EXCEPTION: "onException",
        RESPONSE: "onResponse",
        TRACE: "onTrace"
      },
      REQUEST_HANDLER_TYPE_VALUES = values_default()(REQUEST_HANDLER_TYPE);
    var HttpRequestBuilder_HttpRequestBuilder = function HttpRequestBuilder() {
      var _this3 = this;
      var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      classCallCheck_default()(this, HttpRequestBuilder), defineProperty_default()(this, "addOptions", function (options) {
        return _this3.options || (_this3.options = []), _this3.options.push(options), _this3;
      }), defineProperty_default()(this, "addHandler", function (event, callback) {
        var _context;
        var handler = event;
        event && callback && (handler = _defineProperty({}, event, callback));
        return every_default()(_context = keys_default()(handler)).call(_context, function (eventKey) {
          return !!includes_default()(REQUEST_HANDLER_TYPE_VALUES).call(REQUEST_HANDLER_TYPE_VALUES, eventKey) || (logger_.log.warning("Invalid event type \"".concat(eventKey, "\" supplied to \"HttpRequestBuilder.addHandler()\"")), !1);
        }) ? (_this3.handlers || (_this3.handlers = []), _this3.handlers.push(handler), _this3) : _this3;
      }), defineProperty_default()(this, "build", function () {
        var _context2, _context3;
        var options = _this3.options && reduce_default()(_context2 = _this3.options).call(_context2, function (list, values) {
            return fastOptionsMerge(list, values);
          }),
          handlers = _this3.handlers && reduce_default()(_context3 = _this3.handlers).call(_context3, function (list, values) {
            return _objectSpread({}, list, {}, values);
          });
        return new HttpRequest_HttpRequest(_this3.baseUrl, options, handlers);
      }), this.baseUrl = baseUrl;
    };
    var locale_ = __webpack_require__("@jutro/locale"),
      events_ = __webpack_require__("@jutro/events");
    var eventTopicMap = {
        request: events_.JUTRO_TOPICS.FETCH_REQUEST,
        response: events_.JUTRO_TOPICS.FETCH_RESPONSE,
        error: events_.JUTRO_TOPICS.FETCH_ERROR,
        exception: events_.JUTRO_TOPICS.FETCH_ERROR
      },
      analyticsHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.TRACE, function (event, payload) {
        Object(events_.publish)(eventTopicMap[event], payload);
      }),
      jsonOptions = {
        headers: {
          "Content-Type": "application/json; charset=UTF-8"
        }
      };
    function langLocaleOptions(language, locale) {
      return {
        headers: {
          "gw-language": language,
          "gw-locale": locale
        }
      };
    }
    function createHttpRequest(baseUrl) {
      var build = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var request = new HttpRequestBuilder_HttpRequestBuilder(baseUrl).addOptions(langLocaleOptions(locale_.LocaleService.getCurrentLanguage(), locale_.LocaleService.getCurrentLocale())).addHandler(analyticsHandler);
      return build ? request.build() : request;
    }
    function createJsonHttpRequest(baseUrl) {
      var build = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var request = createHttpRequest(baseUrl, !1).addOptions(jsonOptions);
      return build ? request.build() : request;
    }
    function basicAuthOptions(userName, password) {
      return {
        headers: {
          Authorization: "Basic " + btoa("".concat(userName || "", ":").concat(password || ""))
        }
      };
    }
    function tokenAuthOptions(accessToken) {
      if (Object(logger_.warning)("tokenAuthOptions is deprecated, please use `authTokenHandler` that support token refresh/timeout"), accessToken) return {
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
    }
    var auth_ = __webpack_require__("@jutro/auth");
    var authTokenHandler = _defineProperty({}, REQUEST_HANDLER_TYPE.AUTH, function _callee2() {
      var accessToken;
      return _regeneratorRuntime().async(function _callee2$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _regeneratorRuntime().awrap(Object(auth_.getAccessToken)());
          case 2:
            accessToken = _context7.sent;
            return _context7.abrupt("return", {
              headers: {
                Authorization: "Bearer " + accessToken,
                "GW-Tenant": Object(auth_.decodeJWTTokenPayload)(accessToken).tenant_id
              }
            });
          case 4:
          case "end":
            return _context7.stop();
        }
      }, null, null, null, Promise);
    });
    var external_zipkin_ = __webpack_require__("zipkin"),
      external_zipkin_instrumentation_fetch_ = __webpack_require__("zipkin-instrumentation-fetch"),
      external_zipkin_instrumentation_fetch_default = __webpack_require__.n(external_zipkin_instrumentation_fetch_),
      external_zipkin_transport_http_ = __webpack_require__("zipkin-transport-http"),
      config_ = __webpack_require__("@jutro/config");
    var JSON_V2 = external_zipkin_.jsonEncoder.JSON_V2;
    function zipkinTraceHandler(remoteServiceName, localServiceName, zipkinUrl, debug) {
      var fetchCall = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : fetch;
      var recorder;
      var zipkinDebugConfigValue = Object(config_.getConfigValue)("zipkinDebug"),
        zipkinUrlConfigValue = Object(config_.getConfigValue)("zipkinUrl");
      recorder = debug || zipkinDebugConfigValue ? new external_zipkin_.ConsoleRecorder() : zipkinUrl || zipkinUrlConfigValue ? new external_zipkin_.BatchRecorder({
        logger: new external_zipkin_transport_http_.HttpLogger({
          endpoint: zipkinUrl || zipkinUrlConfigValue,
          jsonEncoder: JSON_V2,
          fetch: fetch
        })
      }) : {
        record: function record() {},
        toString: function toString() {
          return "nullTracer";
        }
      };
      var tracer = new external_zipkin_.Tracer({
        ctxImpl: new external_zipkin_.ExplicitContext(),
        recorder: recorder,
        localServiceName: localServiceName || Object(config_.getConfigValue)("zipkinLocalServiceName")
      });
      return _defineProperty({}, REQUEST_HANDLER_TYPE.FETCH, function (url, options) {
        var theFetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : fetchCall;
        return external_zipkin_instrumentation_fetch_default()(theFetch, {
          tracer: tracer,
          remoteServiceName: remoteServiceName || Object(config_.getConfigValue)("zipkinRemoteServiceName")
        })(url, options);
      });
    }
  },
  "@babel/runtime-corejs3/core-js-stable/date/now": function babel_runtimeCorejs3_coreJsStable_date_now(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/date/now");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/every": function babel_runtimeCorejs3_coreJsStable_instance_every(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/every");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babel_runtimeCorejs3_coreJsStable_instance_forEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/includes": function babel_runtimeCorejs3_coreJsStable_instance_includes(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/includes");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/reduce": function babel_runtimeCorejs3_coreJsStable_instance_reduce(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");
  },
  "@babel/runtime-corejs3/core-js-stable/json/stringify": function babel_runtimeCorejs3_coreJsStable_json_stringify(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/json/stringify");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babel_runtimeCorejs3_coreJsStable_object_keys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/object/values": function babel_runtimeCorejs3_coreJsStable_object_values(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/values");
  },
  "@babel/runtime-corejs3/core-js-stable/promise": function babel_runtimeCorejs3_coreJsStable_promise(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/promise");
  },
  "@babel/runtime-corejs3/core-js-stable/url": function babel_runtimeCorejs3_coreJsStable_url(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/url");
  },
  "@jutro/auth": function jutro_auth(module, exports) {
    module.exports = require("@jutro/auth");
  },
  "@jutro/config": function jutro_config(module, exports) {
    module.exports = require("@jutro/config");
  },
  "@jutro/events": function jutro_events(module, exports) {
    module.exports = require("@jutro/events");
  },
  "@jutro/locale": function jutro_locale(module, exports) {
    module.exports = require("@jutro/locale");
  },
  "@jutro/logger": function jutro_logger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "core-js-pure/features/object/define-property": function coreJsPure_features_object_defineProperty(module, exports) {
    module.exports = require("core-js-pure/features/object/define-property");
  },
  zipkin: function zipkin(module, exports) {
    module.exports = require("zipkin");
  },
  "zipkin-instrumentation-fetch": function zipkinInstrumentationFetch(module, exports) {
    module.exports = require("zipkin-instrumentation-fetch");
  },
  "zipkin-transport-http": function zipkinTransportHttp(module, exports) {
    module.exports = require("zipkin-transport-http");
  }
});